import "@kenzai/ui/src/tokens.css";
import "@kenzai/ui/src/kit.css"; // 共有部品の状態表現（:hover 等・D-82）。tokens の**後**に読む
import "./mobile.css"; // スマホ幅だけの上書き（FR-120・D-68）。tokens.css の**後**に読む

import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
